import { Injectable } from '@angular/core';
import { UserService } from '@features/auth/user.service';
import { createEffect } from '@ngrx/effects';
import { ApplicationInsightsService } from 'app/application-insights/application-insights.service';
import * as LogRocket from 'logrocket';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthEffects {
  constructor(
    private userService: UserService,
    private applicationinsights: ApplicationInsightsService,
  ) {}

  identifyUser$ = createEffect(
    () => this.userService.user$.pipe(
      tap((user) => {
        LogRocket.identify(user.sub);
        this.applicationinsights.identifyUser(user);
      }),
    ),
    { dispatch: false },
  );
}
